import { render, staticRenderFns } from "./shopData.vue?vue&type=template&id=0a8199c4&scoped=true&"
import script from "./shopData.vue?vue&type=script&lang=js&"
export * from "./shopData.vue?vue&type=script&lang=js&"
import style0 from "./shopData.vue?vue&type=style&index=0&id=0a8199c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8199c4",
  null
  
)

export default component.exports